export function formatNumberWithThousandsPlaceSeparators(input: number) {
    const parts = input.toString().split(".");
    const integerPart = parts[0];
    const fractionalPart = parts.length > 0 ? parts[1] : null;
    const withCommas = (+integerPart).toLocaleString();

    return withCommas + (fractionalPart ? `.${fractionalPart}` : "");
}
